import { useState, useEffect, React } from "react";
import './style.css';
import { useNavigate, useParams } from "react-router-dom";
import Account from "./components/account";
import Signature from "./components/signature";
import Others from "./components/others";
import Main from "./components/main";

export default function Settings({ user, account, profile, signature }) {

    const { page } = useParams();

    const [ showEmail, setShowEmail ] = useState(true);
    const [ copied, setCopied ] = useState(false);

    const navigate = useNavigate();

    useEffect(()=> {
        
        document.title = 'Configurações - Moov';
        document.querySelector("meta[name=theme-color]").setAttribute("content", '#202020');

    }, []);

    useEffect(()=> {
        window.scrollTo(0,0)
    }, [ page ]);

    return(
        <div className="content-conta" id="content-conta">
            {page == 'conta' &&
                <Account user={user} account={account} profile={profile} showEmail={showEmail} setShowEmail={setShowEmail} setCopied={setCopied}/>
            }
            {page == 'assinatura' &&
                <Signature account={account} user={user} signature={signature}/>
            }
            {(page == 'outras') &&
                <Others />
            }
            {page == 'principal' &&
                <Main profile={profile} signature={signature} copied={copied} setCopied={setCopied}/>
            }
        </div>
    )
}